import { QueryClient, useMutation, useQuery } from 'react-query';

import { getCharacterDetail, toggleCharacterLike } from '@api/chatbot';
import { QUERY_KEYS } from '@constants';
import { IChatCharacter } from '@model';

export const useChatCharacterQuery = () => {
  const useToggleCharacterLike = (
    characterId: number,
    queryClient: QueryClient
  ) => {
    const query = useMutation(
      QUERY_KEYS.CHARACTER.LIKE(characterId),
      () => toggleCharacterLike(characterId),
      {
        //낙관적 업데이트
        onMutate: async (newLike) => {
          await queryClient.cancelQueries({
            queryKey: QUERY_KEYS.CHARACTER.LIKE(characterId),
          });
          await queryClient.cancelQueries({
            queryKey: QUERY_KEYS.CHARACTER.ONE(characterId),
          });

          const characterQueryKey = QUERY_KEYS.CHARACTER.ONE(characterId);

          const previousCharacter = queryClient.getQueryData<IChatCharacter>(
            QUERY_KEYS.CHARACTER.ONE(characterId)
          );

          const previousLike = previousCharacter?.current_user_like;

          queryClient.setQueryData(
            QUERY_KEYS.CHARACTER.LIKE(characterId),
            newLike
          );

          queryClient.setQueryData(characterQueryKey, {
            ...previousCharacter,
            current_user_like: !previousCharacter?.current_user_like,
          });

          return { previousLike, newLike, previousCharacter };
        },
        onError: (err, newLike, context) => {
          queryClient.setQueryData(
            QUERY_KEYS.CHARACTER.LIKE(characterId),
            context?.previousLike
          );
          queryClient.setQueryData(
            QUERY_KEYS.CHARACTER.ONE(characterId),
            context?.previousCharacter
          );
        },
        onSettled: () => {
          queryClient.invalidateQueries({
            queryKey: QUERY_KEYS.CHARACTER.LIKE(characterId),
          });
          queryClient.invalidateQueries({
            queryKey: QUERY_KEYS.CHARACTER.ONE(characterId),
          });
        },
      }
    );
    return query;
  };

  const useGetCharacterDetail = (characterId: number) => {
    const query = useQuery(QUERY_KEYS.CHARACTER.ONE(characterId), () =>
      getCharacterDetail(characterId)
    );

    return query;
  };

  return { useGetCharacterDetail, useToggleCharacterLike };
};
